export default __webpack_public_path__ + "assets/images/icon-click.c979714798707850b9d4378800e0de2f.svg";